import { DatePicker } from '@atom/mui';

interface Props {
  id: string;
  value: any;
  onChange: (value: any) => void;
  disabled: boolean;
  error: boolean;
  dataCyPrefix: string;
}

const DateInput = ({
  id,
  value,
  onChange,
  disabled,
  error,
  dataCyPrefix,
}: Props) => {
  const handleChange = (date?: Date) => {
    if (!date || date.toString() === 'Invalid Date') {
      onChange(date || '');
    } else if (!Number.isNaN(date.valueOf())) {
      onChange(date.valueOf());
    }
  };

  const dateValue = value ? new Date(value) : null;

  return (
    <DatePicker
      key={id}
      value={dateValue}
      onChange={(newDate: Date) => handleChange(newDate || null)}
      disabled={disabled}
      error={error}
      data-cy={`${dataCyPrefix}DateInput`}
    />
  );
};

export default DateInput;
